import React from 'react'

export default function Version(props) {
    return(
        <div className='text-center small'><p className='text-muted'>version: 2.0.0.8.9 ({props.servername})</p></div>
    )
}
